import { z } from "zod";

export const adminConfigurationSchema = z.object({
    // Original entity fields
    logoS3Key: z.string().nullable(),
    logoFileName: z.string().nullable(),
    logoMimeType: z.string().nullable(),

    logoUrl: z.string().nullable(),

    // Meta fields - use coerce or string().datetime() to handle string dates
    lastModified: z
        .string()
        .datetime()
        .transform((str) => new Date(str)),
    modifiedBy: z.string(),
    createdWhen: z
        .string()
        .datetime()
        .transform((str) => new Date(str)),
    createdBy: z.string(),
});
